import React from "react";
import Figure from 'react-bootstrap/Figure';
import getImageByKey from './getImageByKey';
import Col from 'react-bootstrap/Col';  
import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const Thiscard = (props) => {
    useEffect(
        () =>{
          Aos.init({ duration: 3000});
        },[]
        );
    return (  
      <Col data-aos="zoom-out-right" className="col-10 col-lg-4 offset-1 offset-lg-0 mt-3">
        <div>
        <div class="containerss">
        <div class="cards">
            <div class="face face1">
                <div class="content">
           
      <h4>{props.tittle}</h4>
                <Figure>
      <Figure.Image
        width={101}
        height={100}
        alt="171x180"
        src={getImageByKey(props.img)}
      />
      
    </Figure>
            
                </div>
            </div>
            <div class="face face2">
                <div class="content">
                    <p>{props.description}</p>
                    <a className="btss" href={props.link}>
        <span className="bss"></span>
        <span className="bss"></span>
        <span className="bss"></span>
        <span className="bss"></span>
        {props.btn}
    </a>
                </div>
            </div>
        </div>     
</div>
</div>
</Col>


        
    );
}
 
export default Thiscard ;